module.exports = __webpack_public_path__ + "static/fonts/Jost-Medium.a608cfaf.ttf";